import { ColorTypes } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';

import { AddedProductItemEquityProps } from '../components/Cart/components/AddedProductItem/Equity';
import { useEquityAssetController } from '../components/DynamicAsset/hooks/products/Equity';

import { useBatchTicketCartActionItem } from './batchTicketCartActionItem';

interface useEquityAddedProductItemProps extends AddedProductItemEquityProps {}

export const useEquityAddedProductItem = ({ data: item, type }: useEquityAddedProductItemProps) => {
  const inputIsDisabled = type === 'requiredAttention';

  const { isLoadingAction, onRemoveProduct, onUpdateProduct } =
    useBatchTicketCartActionItem<'equity'>({
      item,
      id: 'equity',
      idSelector: 'productIdNormalized',
      type,
    });

  const { amountItem, priceItem, handleChangeAmountItem, handleChangePriceItem, totalPrice } =
    useEquityAssetController(item, onUpdateProduct);

  const isRequiredAttention = type === 'requiredAttention';
  const isTotalSummary = type === 'totalSummary';
  const useRequestedPriceValue = (isRequiredAttention || isTotalSummary) && item.requestedPrice;
  const useQuantityValue = (isRequiredAttention || isTotalSummary) && item.quantity;
  const requestedPrice = useRequestedPriceValue ? item.requestedPrice! : priceItem;
  const quantityAmount = useQuantityValue ? item.quantity! : amountItem;
  const totalPriceValue = requestedPrice * quantityAmount;
  const totalPriceIsInvalid = totalPrice === 0 || totalPrice > 1000000;

  const hasPriceChangeTax = item.quote.priceChangeTax !== 0;
  const priceChangeTaxIsPositive = item.quote.priceChangeTax >= 0;

  const priceChangeTaxIconColor = priceChangeTaxIsPositive
    ? 'feedback.success.default'
    : 'feedback.error.default';

  const priceChangeTaxTextColor = !hasPriceChangeTax
    ? 'neutral.black'
    : (priceChangeTaxIconColor as ColorTypes.Option);

  const priceChangeTaxIcon: IconographyTypes.Option = priceChangeTaxIsPositive
    ? 'ArrowUp'
    : 'ArrowDown';

  return {
    priceChangeTaxIconColor,
    hasPriceChangeTax,
    priceChangeTaxTextColor,
    priceChangeTaxIcon,
    onRemoveProduct,
    onChangeQuantityItem: handleChangeAmountItem,
    onChangePriceItem: handleChangePriceItem,
    totalPrice: totalPriceValue,
    quantityItem: quantityAmount,
    priceItem: requestedPrice,
    totalPriceIsInvalid,
    isLoadingAction,
    inputIsDisabled,
  };
};
